var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n            "+_vm._s(_vm.$t('feePredefineItem.pageTitle'))+"\n        ")]),_c('ts-breadcrumb',{attrs:{"items":[
            { text: _vm.$t('toHomePage'), href: '/' },
            {
                text: _vm.$t(
                    'feePredefineItem.pageTitle'
                ),
                active: true
            }
        ]}})],1),_c('ts-card',[_c('ts-card-wrapper',[_c('a-tabs',{attrs:{"default-active-key":1,"tab-position":"top"},on:{"change":_vm.callback}},[_c('a-tab-pane',{key:1},[_c('span',{staticClass:"tab-title",attrs:{"slot":"tab"},slot:"tab"},[_c('i',{staticClass:"fas fa-file-invoice"}),_c('span',{staticClass:"tab-text"},[_vm._v(_vm._s(_vm.$t('feePredefineItem.invoice')))])]),(_vm.active_tab == 1)?_c('pre-define'):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }